import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      breadcrumbs: 'breadcrumbs/getBreadcrumbs', // moduleName/getterName
    }),
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'breadcrumbs/SETBREADCRUMBS',
      pushBreadcrumb: 'breadcrumbs/PUSHBREADCRUMBS',
      popBreadcrumb: 'breadcrumbs/POPBREADCRUMBS',
      replaceBreadcrumb: 'breadcrumbs/REPLACEBREADCRUMBS',
      emptyBreadcrumbs: 'breadcrumbs/EMPTYBREADCRUMBS',
    }),
  },
};
